import { StyledTag } from './styles';

export function Tag({ children }: { children?: React.ReactNode }) {
  return <StyledTag>{children}</StyledTag>;
}
